import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../Dashboard";

export const broadcastRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "broadcast",
}).lazy(() => import("./Broadcast.lazy").then((d) => d.Route));
